import { Component, Input, OnInit } from '@angular/core';
import { ProfileSearchResult } from '../../data/ProfileSearchResult';
import { EntitlementService } from '../../services/entitlement.service';
import { CardholderService } from '../../services/cardholder.service';
import { CardholderDetails } from '../../data/CardholderDetails';
import { NCConstants } from '../../data/NCConstants';
import { MessageService } from '../../services/message.service';
import { CustomerAccount } from '../../data/CustomerAccount';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Transaction } from '../../data/Transaction';
import {Card} from "../../data/Card";

@Component({
  selector: 'app-cardholder-visahistory',
  templateUrl: './cardholder-visahistory.component.html',
  styleUrls: ['./cardholder-visahistory.component.css']
})
export class CardholderVisahistoryComponent implements OnInit {
  cardholder: ProfileSearchResult;
  stripAccount: any = { account: '' };
  visaBalance = '';
  selectedPage = 1;
  itemsPerPage = 25;
  customerAccounts: CustomerAccount[];
  pagedResults: Transaction[];
  transactions: Transaction[] = [];
  search_btn_spinner: string;
  loading: boolean;
  dataLoading: boolean;
  transactionDateRange = 34; // This should reflex what is in TransactionController.java
  startDate: NgbDate;
  endDate: NgbDate;
  maxEndDate: NgbDate;
  chipOnly: boolean;
  cardsAccount: Card[];

  constructor(
    private calendar: NgbCalendar,
    private entitlementService: EntitlementService,
    private cardholderService: CardholderService,
    private messageService: MessageService
  ) {}

  static format(date: NgbDate) {
    return (
      ('0' + date.month).slice(-2) +
      '/' +
      ('0' + date.day).slice(-2) +
      '/' +
      date.year
    );
  }

  ngOnInit() {
    this.cardholder = CardholderService.retrieveCardholder();
    this.endDate = this.calendar.getToday();
    this.maxEndDate = this.calendar.getToday();
    const startDateWork = new Date();
    startDateWork.setDate(startDateWork.getDate() - this.transactionDateRange);
    this.startDate = new NgbDate(
      startDateWork.getFullYear(),
      startDateWork.getMonth() + 1,
      startDateWork.getDate()
    );
    this.loadData();
  }

  showNewCardholder(newCardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(newCardholder);
    this.cardholder = newCardholder;
    this.loadData();
  }

  loadData() {
    this.search_btn_spinner = '';
    this.dataLoading = false;

    this.cardholderService
      .getCardholderDetails(this.cardholder.payrollAccount)
      .subscribe(
        (data: CardholderDetails) => {
          this.customerAccounts = data.customerAccounts;
          this.cardsAccount = data.cardList;
          this.stripAccount = data.customerAccounts[0];
        },
        error => {
          if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
            this.messageService.error(error.data);
          } else {
            this.messageService.error(error.message);
          }
        },
        () => {
          this.checkChipOnly();
          this.cardholderService.chipDetails(this.chipOnly);
        }
      );
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  pageSet(page) {
    this.selectedPage = page;
    this.setPagedResults();
  }

  setPagedResults() {
    if (this.transactions.length <= 10) {
      this.pagedResults = this.transactions;
    } else {
      this.pagedResults = this.transactions.slice(
        (this.selectedPage - 1) * this.itemsPerPage,
        (this.selectedPage - 1) * this.itemsPerPage + this.itemsPerPage
      );
    }
  }

  checkChipOnly() {
    const index = this.cardsAccount.findIndex(x => x.type !== 'CHIP');
    this.chipOnly = index < 0;
  }
}
